import { useState } from 'react';

function relativeTime(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const s = Math.floor(diff / 1000);
  if (s < 60) return 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}

function fullTime(iso) {
  return new Date(iso).toLocaleString();
}

export default function HistoryPanel({ history, activeId, onLoad, onDelete }) {
  const [open, setOpen] = useState(false);

  if (history.length === 0) return null;

  return (
    <div className="history-wrap">
      <button className="history-toggle" onClick={() => setOpen((v) => !v)}>
        <span>History</span>
        <span className="history-badge">{history.length}</span>
        <span className="history-chevron">{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div className="history-scroll">
          {history.map((run) => {
            const totalPieces = run.order.reduce((s, o) => s + o.qty, 0);
            const isActive = run.id === activeId;
            return (
              <div
                key={run.id}
                className={`history-card${isActive ? ' history-card--active' : ''}`}
                title={fullTime(run.createdAt)}
              >
                <div className="hcard-time">{relativeTime(run.createdAt)}</div>

                <div className="hcard-row">
                  <span className="hcard-label">Stock</span>
                  <span className="hcard-val">
                    {run.stock.length} type{run.stock.length !== 1 ? 's' : ''}
                    {' · '}
                    {run.stock.reduce((s, x) => s + x.qty, 0)} sheets
                  </span>
                </div>

                <div className="hcard-row">
                  <span className="hcard-label">Order</span>
                  <span className="hcard-val">
                    {run.order.length} item{run.order.length !== 1 ? 's' : ''}
                    {' · '}
                    {totalPieces} pcs
                  </span>
                </div>

                <div className="hcard-row">
                  <span className="hcard-label">Result</span>
                  <span className="hcard-val">
                    {run.result.usedSheets?.length ?? '—'} sheets
                    {' · '}
                    <span
                      style={{
                        color: run.result.efficiency >= 70 ? 'var(--green)' : 'var(--amber)',
                        fontWeight: 600,
                      }}
                    >
                      {run.result.efficiency}%
                    </span>
                  </span>
                </div>

                <div className="hcard-actions">
                  <button
                    className="btn-add hcard-load"
                    onClick={() => onLoad(run)}
                    disabled={isActive}
                  >
                    {isActive ? 'Loaded' : 'Load'}
                  </button>
                  <button
                    className="btn-remove hcard-del"
                    onClick={() => onDelete(run.id)}
                    title="Delete"
                  >
                    ×
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
